import aparat from './socialsIcon/aparat.png';
import facebook from './socialsIcon/facebook.png';
import instagram from './socialsIcon/instagram.png';
import linkedin from './socialsIcon/linkedin.png';
import telegram from './socialsIcon/telegram.png';
import twitter from './socialsIcon/twitter.png';

export const socials = [
  {
    id: 1,
    title: 'اپارات پذیرش 24',
    image: aparat,
    url: 'https://www.aparat.com/paziresh24/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
  {
    id: 2,
    title: 'لینکدین پذیرش 24',
    image: linkedin,
    url: 'https://www.linkedin.com/company/paziresh24/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
  {
    id: 3,
    title: 'تلگرام پذیرش 24',
    image: telegram,
    url: 'https://t.me/paziresh24/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
  {
    id: 4,
    title: 'فیس بوک پذیرش 24',
    image: facebook,
    url: 'https://www.facebook.com/paziresh24com/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
  {
    id: 5,
    title: ' توییتر پذیرش 24',
    image: twitter,
    url: 'https://twitter.com/paziresh24/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
  {
    id: 6,
    title: ' اینستاگرام پذیرش 24',
    image: instagram,
    url: 'https://www.instagram.com/paziresh24/',
    target: '_blank',
    rel: 'noopener noreferrer nofollow',
  },
];
